/**
 * Mouvements nommés du socle — ceux qu'une durée seule ne décrit pas.
 *
 * `transitions.duration` porte l'échelle des durées simples (150 / 200 / 300).
 * Un mouvement qui a une *intention* — se soulever, retomber — tient à sa
 * courbe autant qu'à sa durée, et les deux ne se séparent pas : servir `lift`
 * en 200ms le rend nerveux, le servir en `ease` lui retire ce qui en fait un
 * soulèvement. D'où une chaîne complète plutôt que deux tokens à recomposer.
 */
export const motion = {
  /**
   * Soulèvement d'une surface au survol — carte de catalogue, vignette
   * cliquable.
   *
   * Le `1.2` en ordonnée est un léger dépassement : la surface monte un peu
   * plus haut que sa position finale avant de s'y poser. C'est ce qui la fait
   * lire comme un objet qui *se soulève* plutôt que comme une ombre qui
   * apparaît.
   *
   * 600ms est délibérément hors de l'échelle des durées : le mouvement doit
   * rester perceptible quand le curseur traverse une grille de cartes, où
   * chaque survol ne dure qu'une fraction de seconde. Une valeur de l'échelle
   * y produirait un scintillement.
   */
  lift: "0.6s cubic-bezier(0.34, 1.2, 0.64, 1)",
} as const;

export type MotionScale = typeof motion;
export type MotionToken = keyof MotionScale;
